import {AfterViewInit, Component, OnInit} from '@angular/core';
import {Router, RouterModule} from '@angular/router';
import {AuthService} from '../../../shared/services/auth.service';
import {RewardsSummaryService} from '../../../shared/services/rewards-summary.service';
import {ParamService} from '../../../shared/services/param.service';
import {properties} from '../../../../environments/properties';
import {RewardService} from "../../../shared/services/reward.service";
import {BannerUnitProps} from "../../../shared/models/bannerUnits.model";
import {environment} from "../../../../environments/environment";
import {LogService} from "../../../shared/services/LogService";

declare const $: any;

@Component({
    selector: 'app-manage-rewards',
    templateUrl: './manage-rewards.component.html',
    styleUrls: ['./manage-rewards.component.scss'],
})
export class ManageRewardsComponent implements OnInit {
    public currentEnvironment: string;
    public userInfo: any;
    public isLoggedInTokenValid = false;
    public loading = true;
    public linkBannerForU: string;
    public linkFreshPass: string;
    public hideFreshPassBanner: string;
    public rewardsBalanceCopy: string;
    public freshPassNoExpiryCopy: string;
    public nextRewardCopy: string;
    public showHelpingButtons = true;
    public bannerForUOpenNewTab: string;
    public selectedBanner: string;
    public freshPassOpenNewTab: string;
    public cashRewardsFlow: boolean;
    public AB = window['AB'];
    public appHostURL: any;
    banner: any;
    isUserAuthenticated = false;
    showProgressBar = true;
    freshPassUser = false;
    showPointsScoreCard: boolean;
    showNameBirthMod = false;
    renderGalleryComponent = false;
    rewardsResponseObj: any;
    userProfile: any;
    tokenCaller = 'manage-rewards';


    constructor(public authService: AuthService,
                private _rewardSummaryService: RewardsSummaryService,
                private _rewardService: RewardService,
                private paramService: ParamService,
                private router: RouterModule,
                private logService: LogService,) {
    }

    ngOnInit(): void {
        this.currentEnvironment = this._rewardSummaryService.getEnvironment();
        this.banner = this.paramService.banner;
        this.appHostURL = this.authService.getApplicationDomainURL();
        this.linkBannerForU = '/foru/program-details.html';
        this.linkFreshPass = '/lp/subscriptions-delivery.html';
        this.hideFreshPassBanner = 'false';
        this.rewardsBalanceCopy = 'Rewards Balance';
        this.freshPassNoExpiryCopy = 'Rewards don’t expire with <a href="/lp/subscriptions-delivery.html" target="_blank">FreshPass</a><sup>TM</sup>';
        this.nextRewardCopy = 'Rewards Balance';
        this.bannerForUOpenNewTab = '_blank';
        this.selectedBanner = '';
        this.freshPassOpenNewTab = '/freshpass/manage/subscribe';
        this.showPointsScoreCard = true;
        const getCashRewardFlag = properties.rewardsConfig.cashRewardsBanner[this.banner];
        if (getCashRewardFlag) {
            this.cashRewardsFlow = true;
        } else {
            this.cashRewardsFlow = false;
        }
        if (this.AB && this.AB['DATALAYER'] && this.AB['DATALAYER'].initAngularSPA) {
            this.AB['DATALAYER'].initAngularSPA('rewards', 'dashboard');
        }
        this.getUserInfo();
    }


    getUserInfo() {
        this.authService.populateSessionData$.subscribe((userInfo) => {
            if (userInfo) {
                this.userInfo = userInfo;
                if (userInfo.isTokenValid) {
                    this.isUserAuthenticated = true;
                    this.selectedBanner = userInfo.banner;
                    this.isLoggedInTokenValid = true;
                    this.initLoyaltyProfileComponents();
                    this.initGalleryAPIRendering();

                } else {
                    this.authService.redirectToSSO(userInfo.tokenObject);
                }
            } else {
                this.authService.getUserLogedInToken(this.tokenCaller);
            }
        });
    }

    initLoyaltyProfileComponents() {
        const userNameElement = $('.loyalty-for-u-username');
        const brComponents = $('.loyalty-birthday-rewards-mod-unit');

        if (userNameElement.length > 0 || brComponents.length > 0) {
            this.getProfileData();
        }
    }
    getProfileData() {
        this._rewardSummaryService.getRewardsUCAProfile(this.currentEnvironment, this.userInfo).subscribe((data: any) => {
            if (data) {
                this.showNameBirthMod = true;
                this.loading = false;
                this.userProfile = data?.profile?.personalInfo;
                this.initLoyaltyUserName(this.userProfile);
            }
        }, error => {
            this.loading = false;
            this.showNameBirthMod = true;
        });
    }

    initLoyaltyUserName(profileData: any) {

        const userNameElement = $('.loyalty-for-u-username');
        let userName;
        if (profileData) {
            userName = profileData.name.firstName;
        } else {

            if (this.AB?.userInfo?.firstName) {
                userName = this.AB.userInfo.firstName;
            }
        }
        userNameElement.each(function () {
            const element = $(this);
            const defaultTxt = element.attr('data-default-welcome-text');
            element.find('.loyalty-user-name').text(userName || defaultTxt);
            element.find('.loyalty-user-name-heading').text('Rewards Page')
        });

    }

    initGalleryAPIRendering() {
        this._rewardService.getDataMulticlip(this.userInfo, this.currentEnvironment, this.cashRewardsFlow).subscribe(data => {
            if (data) {
                this.renderGalleryComponent = true;
            }
        }, error => {
            this.logService.log('error', JSON.stringify(error), this.userInfo.env, this.userInfo.banner);
            const errorTitle = 'Service Problem';
            const errorMessage = 'System is currently unavailable, please try again later.';
            window['AB']['COMMON'].popupUserErrorMessage(errorTitle, errorMessage, function () {
                // Refresh the page after user clicks the button.
                window.location.href = '/rewards/dashboard';
            });
        });
    }
}
